"use client";
//#region src/dialog/utils/supports-inert.ts
function supportsInert() {
	return "inert" in HTMLElement.prototype;
}
//#endregion
export { supportsInert };

//# sourceMappingURL=supports-inert.js.map